var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-item-header"},[_c('span',{staticClass:"mod-name"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"mod-requirement"},[_vm._v(_vm._s(_vm.requirement))])])}
var staticRenderFns = []

export { render, staticRenderFns }